import React from "react";
import { Link } from "react-router";

import { ArrowLeftIcon } from "components/Icons";
import { cn } from "tools/ui";

const STYLE_BASE = "min-h-[89vh] p-3 px-8 w-full relative";

function LayoutView({ children, style, link, title }) {
  return (
    <div className={cn(STYLE_BASE, style)}>
      <header className="flex space-x-5 items-center">
        {link && (
          <Link to={`/dash/${link}`}>
            <ArrowLeftIcon className="w-8 h-8" />
          </Link>
        )}
        {title && <h2 className="text-[42px]">{title}</h2>}
      </header>
      {children}
    </div>
  );
}

export default LayoutView;
